import React, { useState, useEffect, Fragment } from 'react';
import CellModal from './CellModal';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellStyle, UpdateInventoryButton, UpdateCellInput } from '../Layout';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_Inventory } from '../../../../../constants/APIs';

// Redux
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Input } from 'reactstrap';
import TimeSlot from './TimeSlot';

function Cell({
  propertyId,
  roomTypeId,
  rate,
  date,
  text,
  stopsell,
  cta,
  ctd,
  isEditingInventoryCell,
  currency,
  timeSlot,
  handleTimeSlots
}) {
  const [flipped, setFlipped] = useState(false);
  const [style, setStyle] = useState({});
  const [isVisible, setIsVisible] = useState(false);
  const [isChanged, setIsChanged] = useState(true);
  const handleUpdate = (e, timeSlot) => {
    handleTimeSlots(e, timeSlot, date, roomTypeId);
  };

  const timeSlots = () => {
    return (
      <Fragment>
        {isChanged === true ? timeSlot.map((m) =>
          <TimeSlot slot={m} handleUpdate={handleUpdate} ></TimeSlot>
        )
          : ''}
      </Fragment>
    );
  }
  return (
    <Fragment>
      {timeSlots()}
    </Fragment >
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, currency } = settings;
  return {
    propertyId,
    currency
  };
};

export default injectIntl(connect(mapStateToProps, {})(Cell));
